import React, { Component } from 'react';
import './App.css';
import rht from './rht';

class Supply extends Component {
  state = {
    totalSupplyWholeNumber: '',
  };

  async componentDidMount() {
    const totalSupplyWholeNumber = await rht.methods.totalSupplyWholeNumber().call();

    this.setState({ totalSupplyWholeNumber });
  }

  render() {
  return (
    <div className='supply'>
      <p>{this.state.totalSupplyWholeNumber} RHT</p>
    </div>
  );
  };
}

export default Supply;
